export default {
  error: 'Fejl',
  sorry: 'Beklager, vi har modtaget følgende fejl',
  workingOnIt:
    'En ingeniør er blevet underrettet om dette problem, og vi arbejder på at løse det så hurtigt som muligt.',
  tryAgain: 'Prøv igen senere',
  noInternet:
    'Der ser ud til at være et problem med din internetforbindelse. Tjek venligst og prøv igen.',
}
